// src/constants/platforms.js


/**
 * Описание всех поддерживаемых платформ в ОДНОМ месте.
 *  id         – slug, участвует в URL, theme-class и cookie
 *  label      – как показывать в UI
 *  color      – базовый цвет для сайдбара (Tailwind или свой класс)
 *  hasFollow  – есть ли отдельная страница «follow»
 */
export const PLATFORMS = [
  { id: 'twitch', label: 'Twitch', color: 'purple', hasFollow: true  },
  { id: 'kick',   label: 'Kick',   color: 'green',  hasFollow: true },
  { id: 'wtv',    label: 'W.tv',   color: 'blue',   hasFollow: true, adminOnly: false },
];